import React, { useContext } from 'react';
import { Box, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

import { Breadcrumbs } from '@occc/ui-design-system';
import MyAccount from './MyAccount';

import { AppLayoutContext } from '../../layout/AppLayout';

const APP_BAR_HEIGHT = 64;

type Props = {
  onSidebarOpen: React.MouseEventHandler<HTMLButtonElement>;
  isSidebarOpen: boolean;
};

export const AppBar: React.FC<Props> = ({ onSidebarOpen, isSidebarOpen }) => {
  const { breadcrumbLinks } = useContext(AppLayoutContext);

  return (
    <Box
      display='flex'
      justifyContent='space-between'
      alignItems='center'
      height={APP_BAR_HEIGHT}
      px={{
        md: 2,
        xs: 1,
      }}
    >
      {!isSidebarOpen && (
        <IconButton
          aria-label='open drawer'
          edge='start'
          onClick={onSidebarOpen}
          sx={{ color: 'inherit', mr: 2 }}
        >
          <MenuIcon />
        </IconButton>
      )}

      {breadcrumbLinks && <Breadcrumbs links={breadcrumbLinks} />}
      <MyAccount />
    </Box>
  );
};
